/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Fragment } from 'react';
import { styled } from 'styled-components';
import { Colors } from '../../../../play-core/styles/Colors';
import { ellipsis } from '../../../../play-core/styles/style-helper';
import { fontBySize, responsiveFontType } from '../ClickableComponents/styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const IconText = ({
  icon,
  iconSize = 24,
  iconColor = 'inherit',
  iconPositionRight = false,
  text,
  fontSize = fontBySize.default,
  fontType = 'Regular',
  fontColor = 'inherit',
  spaceBetween = 10,
  multilineText = false,
  iconIndicator
}) => /*#__PURE__*/_jsxs(Fragment, {
  children: [/*#__PURE__*/_jsxs(Icon, {
    iconSize: iconSize,
    iconColor: iconColor,
    iconPositionRight: iconPositionRight,
    children: [icon, iconIndicator && /*#__PURE__*/_jsx(Indicator, {})]
  }), /*#__PURE__*/_jsx(Text, {
    fontType: fontType,
    fontSize: fontSize,
    fontColor: fontColor,
    spaceBetween: spaceBetween,
    multilineText: multilineText,
    children: text
  })]
});
const Icon = styled.div.withConfig({
  displayName: "IconText__Icon",
  componentId: "sc-1ryx3m9-0"
})(["font-size:", "px;height:", "px;color:", ";box-sizing:content-box;display:flex;order:", ";"], ({
  iconSize
}) => iconSize, ({
  iconSize
}) => iconSize, ({
  iconColor
}) => iconColor, ({
  iconPositionRight
}) => iconPositionRight ? 1 : 0);

// eslint-disable-next-line react/no-children-prop
export const Text = styled(({
  className,
  children
}) => /*#__PURE__*/_jsx("div", {
  className: className,
  children: children
})).withConfig({
  displayName: "IconText__Text",
  componentId: "sc-1ryx3m9-1"
})(["align-items:center;", ";letter-spacing:inherit;padding-left:", "px;white-space:pre-wrap;color:", ";", ";"], responsiveFontType, ({
  spaceBetween
}) => spaceBetween, props => props.fontColor, ({
  multilineText
}) => !multilineText && ellipsis);
const Indicator = styled.span.withConfig({
  displayName: "IconText__Indicator",
  componentId: "sc-1ryx3m9-2"
})(["height:8px;width:8px;background-color:", ";border-radius:50%;margin:0 -8px auto 0;"], Colors.RED_b10017);